// Class: swf.exporters.swflite.timeline._SymbolTimeline.FrameSymbolInstance

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../../../hxClasses_stub").default;
var $hxEnums = require("./../../../../../hxEnums_stub").default;

// Constructor

var FrameSymbolInstance = function(initFrame,initFrameObjectID,characterID,depth,displayObject,clipDepth) {
	this.initFrame = initFrame;
	this.initFrameObjectID = initFrameObjectID;
	this.characterID = characterID;
	this.depth = depth;
	this.displayObject = displayObject;
	this.clipDepth = clipDepth;
}

// Meta

FrameSymbolInstance.__name__ = "swf.exporters.swflite.timeline._SymbolTimeline.FrameSymbolInstance";
FrameSymbolInstance.__isInterface__ = false;
FrameSymbolInstance.prototype = {
	
};
FrameSymbolInstance.prototype.__class__ = FrameSymbolInstance.prototype.constructor = $hxClasses["swf.exporters.swflite.timeline._SymbolTimeline.FrameSymbolInstance"] = FrameSymbolInstance;

// Init



// Statics




// Export

exports.default = FrameSymbolInstance;